<script>
import ModelCreate from "../models/create";
import FormsModel from "@/components/forms/bank_account";

export default {
  extends: ModelCreate,
  page: {
    title: "Create Bank Accounts",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('bank_accounts.singular')) }},
    resourceRoute: {default: 'bank_accounts'},
    modelVariable: {default: 'bank_account'},
    form: {default() { return FormsModel; }}
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('bank_accounts.plural')),
      items: [
        {
          text: this.lodash.upperFirst(this.$t('bank_accounts.plural')),
          href: "/bank_accounts",
        },
        {
          text: this.$t("Create New"),
          href: "/bank_accounts/create",
          active: true,
        },
      ]
    }
  },
  methods: {
    store(value) {
      return this.$axios.post('/bank_accounts', value).catch((e) => {
        if (e.response && e.response.data) {
          this.errors = e.response.data.errors;
        }
        throw e
      });
    },
  }
}
</script>
